import { authenticatedPost } from '../../../../../../api/request';

export default async function createExperience(idDoctorUser, experienceBody, setErrorMessage) {
    const onFail = () => setErrorMessage('Ocurrió un error guardando una experiencia.');
    const url = `/doctor-profile-management/experience/${idDoctorUser}`;
    return await authenticatedPost(url, onFail, experienceBody);
}
